module.exports = __webpack_public_path__ + "img/101_4.fa06e280.png";